export function formatSize(bytes: number) {
    return bytes < 1024 ? `${bytes} B` : `${+(bytes / 1024).toFixed(2)} KB`;
}
